// 런타임에 변경 가능한 게임 옵션. 시작 메뉴에서 사용자가 고른 값을 보관.
// 변경되지 않는 값(색·회전속도 등)은 그대로 CONFIG에 둠.

import { CONFIG } from './config.js';
import type { RuntimeOptions } from './types.js';

let active: RuntimeOptions = {
  pool: CONFIG.pool,
  quizMode: 'mixed',
};

export function getOptions(): RuntimeOptions {
  return active;
}

export function setOptions(next: RuntimeOptions): void {
  active = next;
}
